var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import mergeRefs from 'merge-refs';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import { CheckSVG, MinusSVG } from '@snack-uikit/icons';
import { SIZE } from '../../constants';
import { getIconSize, getVisualStateAttributes } from '../../utils';
import { TogglePrivate } from '../TogglePrivate';
import styles from './styles.module.css';
export function Checkbox(_a) {
    var { inputRef, indeterminate: indeterminateProp, indeterminateDefault, onChange: onChangeProp, 'data-test-id': dataTestId, size = SIZE.M } = _a, restProps = __rest(_a, ["inputRef", "indeterminate", "indeterminateDefault", "onChange", 'data-test-id', "size"]);
    const localRef = useRef(null);
    const ref = mergeRefs(localRef, inputRef);
    const [indeterminate, setIndeterminate] = useUncontrolledProp(indeterminateProp, indeterminateDefault);
    const onChange = useCallback((checked) => {
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(checked);
        setIndeterminate(false);
    }, [onChangeProp, setIndeterminate]);
    useEffect(() => {
        if (localRef.current) {
            localRef.current.indeterminate = Boolean(indeterminate);
        }
    }, [localRef, indeterminate]);
    const iconSize = useMemo(() => getIconSize(size), [size]);
    return (_jsx(TogglePrivate, Object.assign({}, restProps, { size: size, onChange: onChange, "data-test-id": dataTestId, ref: ref, render: function Checkbox(visualState) {
            const data = getVisualStateAttributes(Object.assign(Object.assign({}, visualState), { indeterminate: Boolean(indeterminate) }));
            return (_jsxs("div", Object.assign({ className: styles.container }, data, { children: [_jsx("div", Object.assign({ className: styles.box }, data)), _jsx("div", Object.assign({ className: styles.icon }, data, { children: indeterminate ? _jsx(MinusSVG, { size: iconSize }) : _jsx(CheckSVG, { size: iconSize }) }))] })));
        } })));
}
